<script>
import { Toast } from 'mint-ui';
import VueScrollTo from 'vue-scrollto';
import { Form, FormItem, Dialog } from 'element-ui';
import Radio from '@/components/radio';
import checkbox from '@/components/checkbox';
import hInput from '@/components/input';
import hButton from '@/components/button';
import Cascader from '@/components/cascader/index';
import popover from '@/components/popover';
import { getLanguage } from '@/helper/locales';
import isMobilePhone from 'validator/lib/isMobilePhone';
import coupon from '@/core/coupon/coupon.vue';
import { getSfCity, supportVisitTime, newCreateOrder, getRecycleTypeList, getHsbCity, getAllowCouponList } from '@/apis/base';

export default {
  asyncData ({ store, route }) {
    return store.dispatch('initOrder/getEvInfo', route.params.evID);
  },
  components: {
    'el-form': Form,
    'el-form-item': FormItem,
    'el-dialog': Dialog,
    Radio,
    checkbox,
    hInput,
    hButton,
    Cascader,
    popover,
    coupon
  },
  data () {
    return {
      agree: false,
      orderForm: {
        tel: '',
        payType: '',
        recycleType: '',
        userName: '',
        address: '',
        evaluateid: this.$route.params.evID,
        selectedSFCity: [],
        selectedSMCity: [],
        selectedTimes: [],
        selectedCouponId: [],
        payAccount: '',
        payName: '',
        bankName: '',
        credFlag: 0,
        selectArea: ''
      },
      sfaddr: '',
      sfSupportVisitTime: [],
      smSupportVisitTime: [],
      sfCtiys: [],
      smCtiys: [],
      recycleList: [],
      couponList: [],
      submitting: false,
      SFCityRule: [
        {
          type: 'array',
          required: true,
          message: '请选择城市信息',
          fields: {
            0: {type: 'string', required: true},
            1: {type: 'string', required: true}
          }
        }
      ],
      SMCityRule: [{
        type: 'array',
        required: true,
        message: '请选择城市信息',
        fields: {
          0: {type: 'string', required: true},
          1: {type: 'string', required: true}
        }
      }],
      rules: {
        tel: [
          {
            validator (rule, value, callback) {
              const errors = [];
              if (!value) {
                errors.push(new Error('请输入联系电话'));
              }
              if (!isMobilePhone(value, getLanguage())) {
                errors.push(new Error('请输入正确的联系电话'));
              }
              callback(errors);
            }
          }
        ],
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        selectedTimes: [
          {
            type: 'array',
            required: true,
            message: '请选择预约时间',
            fields: {
              0: {type: 'string', required: true},
              1: {type: 'string', required: true}
            }
          }
        ],
        selectArea: [
          {
            type: 'string',
            required: true,
            message: '请选择街道/小区'
          }
        ]
      }
    };
  },
  computed: {
    evInfo () {
      return this.$store.state.initOrder.info;
    },

    payWayList () {
      return this.$store.state.config.payWayList;
    },

    activeList () {
      return (this.evInfo.activityList && this.evInfo.activityList.slice(0, 2)) || [];
    },

    activeTotalAddPrice () {
      return this.activeList.reduce((pre, item) => {
        return pre + +item.couponMoney;
      }, 0);
    },

    addActivityPrice () {
      return +this.evInfo.quotation + this.activeTotalAddPrice;
    },

    totalPrice () {
      return +this.evInfo.quotation + this.activeTotalAddPrice + (this.selectedCoupon.couponValue >>> 0);
    },

    activityId () {
      return this.activeList.map(at => at.activityId).join(',');
    },

    selectedCoupon () {
      return this.couponList.find(item => item.couponId === this.computedSelectedCouponId) || {};
    },

    selectedSfAddr () {
      const [province, city, county] = this.orderForm.selectedSFCity;
      return {
        province,
        city,
        county
      };
    },

    selectedSMAddr () {
      if (!this.orderForm.selectedSMCity.length) {
        return null;
      }
      const [regionId, county] = this.orderForm.selectedSMCity;
      const city = this.smCtiys.find(item => item.id === regionId).name;
      return {
        regionId,
        city,
        county
      };
    },

    selectedTime () {
      return {
        time: this.orderForm.selectedTimes.join(' ')
      };
    },

    computedSelectedCouponId () {
      return this.orderForm.selectedCouponId.join(',');
    },

    hasCoupon () {
      return this.couponList[0] && this.couponList[0].isCanUse === '1';
    },

    isSM () {
      return this.Q_CONST.RECYCLE_TYPE.SM === this.orderForm.recycleType;
    },

    isSF () {
      return this.Q_CONST.RECYCLE_TYPE.SF === this.orderForm.recycleType;
    },

    isPostSelf () {
      return this.Q_CONST.RECYCLE_TYPE.POST_SELF === this.orderForm.recycleType;
    },

    isBankPay () {
      return this.orderForm.payType === this.Q_CONST.PAY_TYPE.bank;
    }
  },
  methods: {
    supportVist (type) {
      return !(type.id === this.Q_CONST.RECYCLE_TYPE.SM && (this.evInfo.classId === this.Q_CONST.CATE_TYPE.COMPUTER || this.evInfo.quotation < 10000));
    },

    init () {
      if (!this.orderForm.payType && !['fql'].includes(this.$store.state.config.loginType)) {
        this.orderForm.payType = this.payWayList[0].value;
      }

      getSfCity().then(sfret => {
        if (sfret.success) {
          this.sfCtiys = sfret._data.areaList;
        }
      });

      supportVisitTime().then(timeRet => {
        if (timeRet.success) {
          this.sfSupportVisitTime = timeRet._data.sf;
          this.smSupportVisitTime = timeRet._data.hsb;
        }
      });

      getRecycleTypeList().then(ret => {
        if (ret.success) {
          this.recycleList = ret._data.recycleTypeList;
          if (!this.orderForm.recycleType) {
            this.orderForm.recycleType = this.recycleList[0].id;
          }
        }
      });

      getHsbCity().then(smret => {
        if (smret.success) {
          const structedList = smret._data.cityList.map(item => {
            if (Array.isArray(item.sub)) {
              item.sub = item.sub.map(subItem => {
                subItem.id = subItem.name;
                return subItem;
              });
            }
            return item;
          });
          this.smCtiys = structedList;
        }
      });

      this.loadCoupon();
    },

    async loadCoupon () {
      this.couponList = [];
      this.orderForm.selectedCouponId = [];
      const productList = JSON.stringify([{
        proId: this.evInfo.productId,
        price: this.evInfo.quotation,
        num: 1
      }]);
      let recycleType = 2;
      if (this.isSM) {
        recycleType = 3;
      }
      const couponDataRet = await getAllowCouponList({
        productList,
        recycleType
      });
      if (couponDataRet.success) {
        this.couponList = couponDataRet._data.couponsList;
        this.couponList = this.couponList.map(item => {
          return {
            couponId: item.couponsId,
            couponValue: item.couponsValue,
            couponName: item.couponsName,
            validEndTime: item.couponsValidity,
            couponValueLimit: item.minQuation,
            isCanUse: item.isCanUse
          };
        });
        // 有可用优惠券
        if (this.hasCoupon) {
          this.orderForm.selectedCouponId = [this.couponList[0].couponId];
        }
      }
    },

    goToForm () {
      let scrollEl = this.$refs.orderForm.$el;
      const firstErrorEl = scrollEl.querySelector('.is-error');
      if (firstErrorEl) {
        scrollEl = firstErrorEl;
      }
      VueScrollTo.scrollTo(scrollEl, 300);
      this.vaildFailHandler && this.vaildFailHandler(this.$refs.orderForm);
      this.submitting = false;
    },

    validateField (field) {
      this.$refs.orderForm.validateField(field);
    },

    validateForm () {
      return this.$refs.orderForm.validate();
    },

    async createOrder (agreeMsg = '') {
      let formData = this.orderForm;
      let result = false;
      this.submitting = true;
      try {
        result = await this.validateForm();
      } catch (err) {
        console.log(err);
      }
      // 表单校验不通过
      if (!result) {
        this.$nextTick().then(() => {
          this.goToForm();
          this.submitting = false;
        });
        return;
      }
      // 未接受服务协议
      if (!this.agree && agreeMsg) {
        Toast({message: agreeMsg});
        this.submitting = false;
        return;
      }
      formData = Object.assign({
        activityId: this.activityId,
        couponId: this.computedSelectedCouponId
      }, this.selectedTime, this.orderForm, this.otherForm);

      if (this.isSM) {
        Object.assign(formData, this.selectedSMAddr || {});
        if (this.orderForm.selectArea) {
          formData.address = this.selectedArea.address + this.selectedArea.name + this.orderForm.address;
          formData.province = formData.province || this.selectedArea.province || '';
          formData.city = formData.city || this.selectedArea.city || '';
        }
      }

      if (this.isSF) {
        Object.assign(formData, this.selectedSfAddr);
      }

      this.submitting = true;
      let orderResult = null;
      try {
        orderResult = await newCreateOrder(formData);
      } catch (err) {
        orderResult = {
          _errStr: '下单异常!'
        };
      }
      this.submitting = false;
      if (!orderResult || !orderResult.success) {
        Toast(orderResult._errStr);
        return;
      }

      this.toInitOrder(orderResult);
    },

    toInitOrder (orderResult) {
      this.$router.push(`/orderCompletion/${orderResult._data.orderNum}`);
    }
  },
  mounted () {
    this.init();
  }
};
</script>



// WEBPACK FOOTER //
// src/core/initOrder/index.vue